import {baseConfig} from '../helpers/baseConfig'
import colors from '../../../../theme/foundations/colors'

const updateBrandIcons = () => {
    const paymentMethods = document.querySelectorAll('.adyen-checkout__payment-method')
    if (!paymentMethods.length) return

    paymentMethods.forEach((method) => {
        const headerIconWrapper = method.querySelector(
            '.adyen-checkout__payment-method__image__wrapper'
        )

        const creditCardImages =
            // not loaded form case: images on payment header
            method.querySelector('.adyen-checkout__payment-method__brands') ||
            // loaded form case: images on payment form
            method.querySelector('.adyen-checkout__card__brands')

        if (headerIconWrapper && creditCardImages) {
            const icons = Array.from(
                creditCardImages.querySelectorAll('.adyen-checkout-brand-wrapper')
            ).map((icon) => icon.cloneNode(true))

            if (icons.length) {
                headerIconWrapper.replaceChildren(...icons)
                headerIconWrapper.style.opacity = 1
            }
        }
    })
}

export const cardConfig = (props) => {
    const cardDetails = {
        endDigits: '',
        issuerBin: ''
    }
    return {
        ...baseConfig({
            ...props,
            cardDetails
        }),
        _disableClickToPay: true,
        showPayButton: true,
        hasHolderName: true,
        holderNameRequired: true,
        billingAddressRequired: false,
        enableStoreDetails: false,
        styles: {
            base: {
                fontSize: '12px'
            },
            placeholder: {
                transition: 'inherit',
                fontSize: '12px',
                color: colors.darkGray
            },
            error: {
                color: colors.red
            }
        },
        onLoad: () => {
            updateBrandIcons()
        },
        onFieldValid: (field) => {
            if (field?.fieldType === 'encryptedCardNumber') {
                cardDetails.endDigits = String(field.endDigits) || ''
                cardDetails.issuerBin = String(field.issuerBin) || ''
            }
            return
        }
    }
}

export const bcmcConfig = (props) => {
    return {
        ...baseConfig(props),
        onLoad: () => {
            updateBrandIcons()
        }
    }
}
